'use client'

import React, { useState } from 'react'

import styles from './ReadMore.module.css'

export interface ReadMoreProps {
  children: React.ReactNode
}

export const ReadMore: React.FC<ReadMoreProps> = ({ children }) => {
  const [showMore, setShowMore] = useState(false)

  return (
    <div className={styles.readMoreContainer}>
      <button className={styles.readMoreButton} onClick={() => setShowMore(!showMore)}>
        {showMore ? 'Show less' : 'Read more'}
      </button>
      {showMore && <div className={styles.content}>{children}</div>}
    </div>
  )
}

export default ReadMore
